export const UnionIcon: React.FC = () => {
  return (
    <svg width='19' height='12' viewBox='0 0 19 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='5.99976' cy='5.99976' r='5.49976' fill='white' stroke='white' />
      <circle cx='12.0017' cy='5.99976' r='5.49976' fill='white' stroke='white' />
    </svg>
  )
}
